import { render, staticRenderFns } from "./MenuListPage.vue?vue&type=template&id=c1c31efa&scoped=true&"
import script from "./MenuListPage.vue?vue&type=script&lang=ts&"
export * from "./MenuListPage.vue?vue&type=script&lang=ts&"
import style0 from "./MenuListPage.vue?vue&type=style&index=0&id=c1c31efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c31efa",
  null
  
)

export default component.exports